import CONSTANTS from '../constants';
import AppService from "./appService";
import CacheService from './cacheService';
import axios from 'axios';

export default {
    getActivities
};

async function getActivities(skipAuth = false, businessName = null, options = {}) {
    if (skipAuth) {
        return axios.get(`${CONSTANTS.URLS.ROOT}${CONSTANTS.URLS.END_POINTS.CONFIG.ACTIVITIES}`, {
            params: options,
            headers: {
                'Business-Name': businessName,
                'Skip-Load-Resource': true
            }});
    }
    let newAccessToken = await AppService.refreshAccessToken();
    return axios.get(`${CONSTANTS.URLS.ROOT}${CONSTANTS.URLS.END_POINTS.CONFIG.ACTIVITIES}`, {
        params: options,
        headers: {
            'Business-Name': CacheService.getToken().bname,
            'Access-Token': newAccessToken
        }});
}
